import React from "react";
import { Box, Flex, Text, type Icon, type FlexProps } from "@chakra-ui/react";
import { type BrandColorToken } from "theme/colors";
import { MotionBox } from "ui/chakra-motion";
import { MapIcon, MinusCircleIcon, PersonWithCheckIcon, SendIcon, TargetIcon, TrendIcon } from "ui/icons";

export function UseCaseCards() {
  return (
    <MotionBox
      display="flex"
      alignItems="center"
      justifyContent="center"
      pos="absolute"
      top={0}
      right={0}
      bottom={0}
      left="auto"
      w="50%"
      initial="hidden"
      animate="visible"
    >
      <UseCaseCard
        className="card"
        iconBgColor="new.blue.500"
        iconColor="new.blue.150"
        icon={SendIcon}
        title={`Same-session \npersonalization`}
        left="42%"
        top="44%"
        opacity={0}
      />

      <UseCaseCard
        className="card"
        iconBgColor="new.yellow.300"
        iconColor="new.yellow.700"
        icon={PersonWithCheckIcon}
        title={`Profile \nenrichment`}
        top="22%"
        right="16%"
        opacity={0}
      />

      <UseCaseCard
        className="card"
        iconBgColor="new.violet.700"
        iconColor="new.violet.150"
        icon={TargetIcon}
        title={`Audience \ntargeting`}
        left="12%"
        bottom="24%"
        opacity={0}
      />

      <UseCaseCard
        className="card"
        iconBgColor="new.green.300"
        iconColor="new.green.700"
        icon={MapIcon}
        title={`Journey \norchestration`}
        left="68%"
        bottom="30%"
        opacity={0}
      />

      <UseCaseCard
        className="card"
        iconBgColor="new.red.500"
        iconColor="new.red.150"
        icon={MinusCircleIcon}
        title={`Audience \nsuppression`}
        bottom="12%"
        right="28%"
        opacity={0}
      />

      <UseCaseCard
        className="card"
        iconBgColor="new.green.500"
        iconColor="new.green.50"
        icon={TrendIcon}
        title={`Conversion \nuploads`}
        left="20%"
        top="11%"
        opacity={0}
      />
    </MotionBox>
  );
}

type UseCaseCardProps = {
  iconBgColor: BrandColorToken;
  iconColor: BrandColorToken;
  icon: typeof Icon;
  title: string;
} & FlexProps;

function UseCaseCard({ iconBgColor, iconColor, icon, title, ...flexProps }: UseCaseCardProps) {
  return (
    <Flex
      display="flex"
      align="center"
      borderRadius="small"
      bg="white"
      boxShadow="md"
      gap="smallest"
      justify="start"
      w="fit-content"
      py="16px"
      px="20px"
      pos="absolute"
      {...flexProps}
    >
      <Flex
        boxSize={{ base: "32px", lg: "40px" }}
        bg={iconBgColor}
        borderRadius="10px"
        color={iconColor}
        align="center"
        flexShrink={0}
        justify="center"
      >
        <Box as={icon} boxSize={{ base: "icon.sm", sm: "icon.md" }} />
      </Flex>
      <Text
        as="span"
        color="brand.textSecondary.light"
        fontSize={{ base: "brand.xs", lg: "brand.sm" }}
        whiteSpace="pre-wrap"
      >
        {title}
      </Text>
    </Flex>
  );
}
